export const UI_BUILD_VERSION = '2.8.5';
